import useCanUseAiEdit from './useCanUseAiEdit.hook';
import useCanUseAiQa from './useCanUseAiQa.hook';

const useCanUseAiAssistantSidebar = () => {
  const canUseAiQa = useCanUseAiQa();
  const canUseAiEdit = useCanUseAiEdit();

  return canUseAiQa || canUseAiEdit;
};

export default useCanUseAiAssistantSidebar;
